import { fetchViaProxy } from '@/actions/proxy-fetch';
import Dialog from '@/components/next-ui/Dialog';
import useUserProfile from '@/hooks/useUserProfile';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import ContributorCard from './ContributorCard';
import Spinner from '../Spinner';

function TopContributorsDialog(props) {
  const { open, title, onClose } = props;
  const userProfile = useUserProfile();
  const { data, isLoading } = useQuery({
    queryKey: ['top-contributors', userProfile?.activeCommunity?.id],
    queryFn: async () => {
      const { ok, data } = await fetchViaProxy(
        '/proxy/v2/protected/users/me/community/active/top-change-makers',
      );

      if (ok) {
        return data;
      }
      throw new Error('Failed to fetch top contributors');
    },
  });

  const users = data?.changeMakers;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      isOpen={open}
      maxWidth="lg"
      title={title}
      contentClass="p-0 lg:p-0 bg-body-background lg:bg-white overflow-y-auto"
      titleClass="pb-2"
      onClose={() => handleClose()}>
      <div className="flex h-full w-full flex-col px-0 py-4 sm:px-4 md:px-6 lg:px-8">
        {isLoading ? (
          <div className="flex items-center justify-center">
            <Spinner size="lg" />
          </div>
        ) : (
          <div className="flex w-full flex-col pb-2">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-8 lg:grid-cols-3">
              {users?.map((user) => (
                <ContributorCard key={user.id} user={user} />
              ))}
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
}

export default TopContributorsDialog;
